import ProductAbstract from './ProductAbstract';

export default ProductAbstract;
